import { defineMessages, type IntlShape } from 'react-intl';
import logError from '@alltrails/core/utils/logError';
import type { AllTrailTraffic } from '../types/TrailTraffic';

const messages = defineMessages<AllTrailTraffic>({
  light: { defaultMessage: 'Light' },
  moderate: { defaultMessage: 'Moderate' },
  heavy: { defaultMessage: 'Heavy' },
  'extra-heavy': { defaultMessage: 'Extra heavy' }
});

export default function getTrailTrafficLabel(intl: IntlShape, trailTraffic: AllTrailTraffic): string {
  const message = messages[trailTraffic];

  if (message) {
    return intl.formatMessage(message);
  }

  logError(new Error(`Unknown trail traffic: ${trailTraffic}`));
  return '';
}
